<template>
  <b-modal :active.sync="isModalActive" has-modal-card :can-cancel="false">
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ modalHeader }}</h1>
      </header>
      <section class="modal-card-body">
        <b-field label="Select a Date">
          <b-datepicker
            class="analytics-date-picker actual-submission-start-date"
            v-model="setTime"
            required
            icon="calendar-today"
            trap-focus
            :date-formatter="dateFormatter"
          >
          </b-datepicker>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" @click="submit">OK</button>
        <b-button type="is-normal button" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";

export default {
  name: "SetTimeModal",
  mixins: [UtilityMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    modalHeader: {
      type: String,
      default: "Action"
    },
    formData: {
      type: Date
    }
  },

  data() {
    return {
      isModalActive: false,
      loading: "",
      setTime: this.formData
    };
  },

  methods: {
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },

    cancel() {
      this.setTime = null;
      this.$emit("cancel");
    },

    submit() {
      this.$emit("confirm", this.setTime);
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    formData(newDate) {
      this.setTime = newDate;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.setTime = new Date();
        this.cancel();
      }
    }
  }
};
</script>
